import {
  Alert,
  AlertDescription,
} from "@nimble/react-requests/components/ui/alert";
import { Clock } from "lucide-react";

import { quizDescriptionDataTestIds } from "@/lib/data-test-ids/quiz.data-test-ids";
import { cn } from "@/lib/utils";

export default function QuizDescriptionCard({
  matchingMessage,
  isSeasonNotice = false,
}: {
  matchingMessage: string;
  isSeasonNotice?: boolean;
}) {
  const matchingMessageParagraph = (
    <p
      className={cn(
        "text-sm text-ink-emphasis",
        isSeasonNotice ? "leading-relaxed" : "font-medium",
      )}
      data-testid={
        quizDescriptionDataTestIds.QUIZ_DESCRIPTION_MATCHING_REASSURANCE_MESSAGE
      }
    >
      {matchingMessage}
    </p>
  );

  return (
    <div
      className="w-full text-left mb-6"
      data-testid={quizDescriptionDataTestIds.QUIZ_DESCRIPTION_CARD}
    >
      <div
        data-testid={quizDescriptionDataTestIds.QUIZ_DESCRIPTION_CARD_CONTENT}
      >
        <div className="flex flex-col gap-5">
          <DescriptionSection
            title="How it works"
            content="Imagine you are offered jobs at three different schools. We'll show you their key attributes like salary, academic growth, and student-teacher ratio."
            dataTestId={
              quizDescriptionDataTestIds.QUIZ_DESCRIPTION_HOW_IT_WORKS_SECTION
            }
          />
          <DescriptionSection
            title="Your task"
            content="Rank the schools in order of preference (1st, 2nd, 3rd choice). You can drag and drop the cards or use the buttons on mobile."
            dataTestId={
              quizDescriptionDataTestIds.QUIZ_DESCRIPTION_YOUR_TASK_SECTION
            }
          />
        </div>
        <div className="border-t border-border mt-5 pt-4">
          {isSeasonNotice ? (
            <Alert
              className="border-transparent bg-success-soft"
              data-testid={
                quizDescriptionDataTestIds.QUIZ_DESCRIPTION_SEASON_NOTICE
              }
            >
              <Clock className="text-success" />
              <AlertDescription>{matchingMessageParagraph}</AlertDescription>
            </Alert>
          ) : (
            matchingMessageParagraph
          )}
        </div>
      </div>
    </div>
  );
}

function DescriptionSection({
  title,
  content,
  dataTestId,
}: {
  title: string;
  content: string;
  dataTestId: string;
}) {
  return (
    <div data-testid={dataTestId}>
      <h3 className="text-sm font-bold text-foreground mb-1.5">{title}</h3>
      <p className="text-sm text-muted-foreground leading-relaxed">{content}</p>
    </div>
  );
}
